<template>
  <div>
    <Head title="Create Organization" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/organizations">Packages</Link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <text-input v-model="form.price" class="pb-8 pr-6 w-full lg:w-1/2" label="Price" />
          <text-input v-model="form.currency" class="pb-8 pr-6 w-full lg:w-1/2" label="currency" />
          <select-input v-model="form.service_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Service">
            <option v-for="service in services" :key="service.id" :value="service.id">{{service.name}}</option>
          </select-input>
          <textarea-input v-model="form.description" class="pb-8 pr-6 w-full" label="Description" />
          
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create Service</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput
  },
  layout: Layout,
  remember: 'form',
  props: {
    services: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        description: null,
        price: null,
        currency: null,
        service_id: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/packages')
    },
  },
}
</script>
